let latitude = window.latitude;
let longitude = window.longitude;

function initMap() {
    let coordinates = new google.maps.LatLng(latitude, longitude);

    let map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: latitude, lng: longitude },
        zoom: 13,
        disableDefaultUI: false,
        gestureHandling: "auto",
        styles: [
            {
                featureType: "poi",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "administrative",
                elementType: "labels.text.fill",
                stylers: [
                    {
                        visibility: "on",
                    },
                    {
                        color: "#1FB4E9",
                    },
                ],
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#D6E6F5",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "geometry",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit.line",
                elementType: "labels",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
        ],
    });

    let marker = new google.maps.Marker({
        position: coordinates,
        map,
    });
}

window.initMap = initMap;
